module.exports = __webpack_public_path__ + "img/collection-engagementRingsModern.8fa3f23.webp";